module.exports = __webpack_public_path__ + "static/media/julie.6aaa997e.jpg";